<app-section-banner [title]="'error.title' | translate" [backgroundImage]="'assets/img/banner_error.png'">
</app-section-banner>

<section class="flex items-center justify-center min-h-screen mt-10 px-4 sm:px-6 lg:px-8">
  <div class="text-center mb-6 text-[#020042] max-w-lg lg:max-w-2xl xl:max-w-3xl mx-auto">

    <picture>
      <source [srcset]="'assets/webp/error.webp' | imageConverter" type="image/webp">
      <img [src]="'assets/img/error.png' | imageConverter" alt="404 Error"
        class="mx-auto mb-12 w-full md:w-2/3 lg:w-[160%] xl:w-[120%] max-w-full">
    </picture>

    <h1 class="text-2xl sm:text-3xl font-bold mb-6">{{ 'error.heading' | translate }}</h1>

    <p class="text-sm sm:text-base font-extralight leading-loose mb-8">
      {{ 'error.description_part1' | translate }}<br>
      <span [innerHTML]="'error.description_part2' | translate"></span>
      {{ 'error.description_part3' | translate }}

    </p>

    <button (click)="router.navigate(['/'])" [attr.aria-label]="'error.cta_aria' | translate"
      class="px-6 py-3 bg-[#5173EF] text-[#F2F4FE] font-extralight text-sm sm:text-base tracking-wide rounded hover:bg-[#ffffff] hover:text-[#020042] transition-all">
      {{ 'error.cta' | translate }}
    </button>
  </div>
</section>